<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar
    [color]="mobile() ? '' : 'secondary-detail'"
    [class.detail-page]="!mobile()"
  >
    @if (mobile()) {
    <ion-title> Rechnung </ion-title>
    } @if (!mobile() && invoice$ | async; as invoice) {
    <ion-title class="text-center">
      Rechnung vom {{ invoice.invoice_date | date : "dd.MM.yyyy" }}
    </ion-title>
    }
    <ion-buttons slot="start">
      <ion-back-button [text]="originPage"></ion-back-button>
      @if (isModal) {
      <ion-button (click)="closeModal()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
      }
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="presentInvoiceActionSheet()">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
    </ion-buttons>
    @if (loading$ | async; as loading) {
    <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>
</ion-header>

@if (invoice$ | async; as invoice) {
<ion-content class="max-width-content">
  <div [class.padding-content]="!mobile()">
    <ion-card class="mt-2 mb-2" [class.no-margin]="!mobile()">
      @if (studentSignal(); as student) {
      <ion-card-header>
        <ion-card-title
          >{{ student?.forename }} {{ student?.surname }}</ion-card-title
        >
        <ion-card-subtitle
          >Fällig am:
          {{ invoice.due_date | date : "dd.MM.yyyy" }}</ion-card-subtitle
        >
      </ion-card-header>
      }

      <ion-card-content>
        <div class="flex flex-row justify-between">
          <p>Rechnungsbetrag</p>
          <p>CHF {{ invoice.total_amount | number : "1.2-2" }}</p>
        </div>
      </ion-card-content>
    </ion-card>

    @if ((invoice.paid_amount ?? 0) !== invoice.total_amount) {
    <div
      class="flex flex-row justify-between mb-6"
      [class.mt-3]="!mobile()"
      [class.mb-6]="mobile()"
      [class.px-3]="mobile()"
    >
      <ion-button mode="ios" class="w-1/2" (click)="sendReminder()">
        Zahlungserinnerung
      </ion-button>
      <ion-button mode="ios" class="w-1/2" (click)="createPayment()">
        <ion-label>Neue Zahlung</ion-label>
      </ion-button>
    </div>
    }
    <ion-item-divider class="mt-6">
      <ion-label>Zusammenfassung</ion-label>
    </ion-item-divider>
    <div class="ion-padding !pt-0 !pb-0">
      <ion-col>
        <div class="flex flex-row align-baseline justify-between">
          <ion-note class="text-sm">Gesamt</ion-note>
          <ion-note class="text-sm"
            >CHF {{ invoice.total_amount | number : "1.2-2" }}</ion-note
          >
        </div>
        @for (payment of invoice.invoice_payment; track payment) {
        <div class="mt-1 flex flex-row align-baseline justify-between">
          <ion-note class="text-sm"
            >Zahlung {{ payment.date | date : "dd.MM.yyyy" }}</ion-note
          >
          <ion-note class="text-sm"
            >CHF {{ payment.amount | number : "1.2-2" }}</ion-note
          >
        </div>
        }
        <div class="mt-3 flex flex-row align-baseline justify-between">
          <ion-label>Offener Betrag</ion-label>
          <ion-label
            >CHF
            {{
              invoice.total_amount - invoice.paid_amount | number : "1.2-2"
            }}</ion-label
          >
        </div>
      </ion-col>
    </div>
    <ion-item-divider class="mt-4">
      <ion-label>Rechnungsverlauf</ion-label>
    </ion-item-divider>
    <div
      class="border-gray-100 dark:border-darkandroid ml-6 -mt-6 border-0 border-l-2 border-solid"
    >
      <div class="pt-2 mt-6 pb-2 pl-4 ml-4">
        <div class="rounded-full h-3 w-3 bg-quickdrive absolute point"></div>
        <h1 class="text-sm mb-0">Rechnung erstellt</h1>
        <span class="text-xs text-gray-500 -mt-6">{{
          invoice.created_at | date : "dd.MM.yyyy HH:mm"
        }}</span>
        @for (invoiceStatus of history$ | async; track invoiceStatus) {
        <div
          class="rounded-full h-3 w-3 absolute point"
          [ngStyle]="{
            'background-color':
              invoiceStatus.status === 'paid' ? '#10B981' : '#0054e9'
          }"
        ></div>
        <h1 class="text-sm mb-0">
          {{ invoiceStatus.status | translateStatus }}
        </h1>
        <span class="text-xs text-gray-500 -mt-6">{{
          invoiceStatus.created_at | date : "dd.MM.yyyy HH:mm"
        }}</span>

        }
      </div>
    </div>
  </div>
</ion-content>
}

<ion-footer></ion-footer>
